import React from 'react';
import { Status } from '../interfaces/Status';

type Props = {
  status: Status | null
}

export default function CurrentStatus ({ status = null }: Props): React.ReactElement {
  return (
    <div className="box">
      <div className="columns">
        <div className="column">
          <p className="title is-level-3">Statut</p>
        </div>
        <div className="column is-narrow">
          <span className="tag is-secondary">{ status ? status.tag : 'Statut inconnu' }</span>
        </div>
      </div>
      { status && 
        <p className="text is-level-1 is-marginless">{ status.label }</p>
      }
    </div>
  );
}